import { ButtonLink } from "design-system/atoms/Button"
import { useTranslation } from "react-i18next"

type Props = {
  autoTopupEnabled: boolean | undefined
  hasSubscription: boolean
  addonIsError: boolean
}

export function AutoTopup({ autoTopupEnabled, hasSubscription, addonIsError }: Props) {
  const { t } = useTranslation()

  if (autoTopupEnabled) return null
  if (!hasSubscription && !addonIsError) return null

  if (hasSubscription) {
    return (
      <>
        <div className="flex w-full justify-center">
          <ButtonLink variant="secondary" to="/settings/subscription/usage/configure-topups">
            {t("subscription.usage.setupAutoTopup")}
          </ButtonLink>
        </div>
        <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
          <span>{t("subscription.usage.addonExplanation.notSetup.withSubscription")}</span>
        </div>
      </>
    )
  }

  if (addonIsError) return null

  return (
    <>
      <div className="flex w-full justify-center">
        <ButtonLink variant="secondary" to="/settings/subscription/usage/configure-topups">
          {t("subscription.usage.setupAutoTopup")}
        </ButtonLink>
      </div>
      <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
        <span>{t("subscription.usage.addonExplanation.notSetup.withoutSubscription")}</span>
      </div>
    </>
  )
}
